import { Component, OnInit, Input } from '@angular/core';
import { CommonService } from '../service/common.service';
import { ShareService } from '../service/share.service';
import { AnalysisService } from '../service/analysis.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { timeout } from 'rxjs/operators';
import { UsersService } from '../service/users.service';
import { Role } from '../app.constant';

import { QuestionType } from '../app.constant'

@Component({
  selector: 'app-a0114-result-analysis',
  templateUrl: './a0114-result-analysis.component.html',
  styleUrls: ['./a0114-result-analysis.component.css']
})
export class A0114ResultAnalysisComponent implements OnInit {
  @Input() event_id: number;
  title = 'Loading...';
  page: number = 1;
  isLoaded: boolean = false;
  isTargetGraphShow: boolean = false;
  isMainGraphShow: boolean = false;

  question_list: any = [];
  start_question_list: any = [];
  category_info: any = null;
  category_list: any = [];
  event: any = [];

  languagelist: any = [];

  selected_t_question_category_id: number = null;
  selected_language_id: number = null;

  QUESTION_TYPE: any = QuestionType;
  ROLE: any = Role;
  
  constructor(
    private commonService: CommonService,
    private shareService: ShareService,
    private analysisService: AnalysisService,
    public usersService: UsersService,
    private router: Router,
    private route: ActivatedRoute,
    private location: Location,
  ) { }

  ngOnInit() {
    this.selected_language_id = +this.route.snapshot.paramMap.get('lid');
    this.selected_t_question_category_id = +this.route.snapshot.paramMap.get('qcid');
    this.getList();
    //画面上部へ移動
    window.scrollTo(0, 0);
  }

  clearData(): void {
    this.title = '…';
    this.isLoaded = false;

    this.question_list = [];
    this.start_question_list = [];
    this.category_info = null

    this.languagelist = [];
  }

  getList(): void {
    this.clearData();
    this.analysisService.getQuestionList(this.selected_t_question_category_id, this.selected_language_id)
      .subscribe((res: Response) => {
        if (res["fuel_status"] == "OK") {
          this.event = res["fuel_results"]["event"];
          if (this.event.length==0){
            //対象のイベントがないメッセージを表示し、イベント一覧画面へ飛ばす
            this.commonService.modalOpens(11007,modalresult=>{
                this.router.navigate(["/event"]);
                });
            }
          this.question_list = res["fuel_results"]["question_list"];
          this.start_question_list = res["fuel_results"]["start_question_list"];
          this.category_info = res["fuel_results"]["category_info"];
          this.category_list = res["fuel_results"]["category_list"];
          this.title = this.category_info["q_title"];
          this.isLoaded = true;
        }else if (res["fuel_status"] == "NG") {
          this.commonService.modalOpens(res["fuel_message"],modalresult=>{});
        }else{
          this.commonService.modalOpens(11003,modalresult=>{});
        }
      }, error => {
        this.commonService.modalOpens(error, modalresult => { });
      });
  }

  // checkMainLanguage(): boolean {

  //   var row = this.languagelist.filter(
  //     item =>
  //       item.m_language_id == this.selected_language_id && item.main_language_flg == 1
  //   );

  //   if (row.length > 0) {
  //     return true;
  //   } else {
  //     return false;
  //   }
  // }

  changeCategory(){
    this.router.navigate(["/result-analysis/"+this.selected_t_question_category_id+"/"+this.selected_language_id]);
    //上ので画面遷移しない…
    this.getList();
  }
  
  goPreviousQuestion(id){
    this.selected_t_question_category_id = id;
    this.router.navigate(["/result-analysis/"+this.selected_t_question_category_id+"/"+this.selected_language_id]);
    //上ので画面遷移しない…
    this.getList();

  }
  setGraph(selectQuestion: any) {

    if (selectQuestion.check != null && selectQuestion.check) {
      selectQuestion.check = false;
    } else {
      selectQuestion.check = true;
    }

  }

  allOpenGraphTarget() {
    //flgの切り替え
    this.isTargetGraphShow = !this.isTargetGraphShow;

    let targetList = this.start_question_list;
    for (let sq in targetList) {
      if (targetList[sq]["previous_flg"] == 1
      ) continue;
      targetList[sq]["check"] = this.isTargetGraphShow;
    }
  }

  allOpenGraphMain() {
    //flgの切り替え
    this.isMainGraphShow = !this.isMainGraphShow;

    let mainList = this.question_list;
    for (let mq in mainList) {
      if (mainList[mq]["q_type_id"] == this.QUESTION_TYPE.TEXTBOX
        || mainList[mq]["q_type_id"] == this.QUESTION_TYPE.TEXTAREA
        || mainList[mq]["q_type_id"] == this.QUESTION_TYPE.DATEYYYYMMFROMTO
        || mainList[mq]["q_type_id"] == this.QUESTION_TYPE.LABELTEXT1
      ) continue;

      mainList[mq]["check"] = this.isMainGraphShow;
      let main2List = mainList[mq]["n_question_list"];
      for (let mq2 in main2List) {
        if (main2List[mq2]["q_type_id"] == this.QUESTION_TYPE.TEXTBOX
          || main2List[mq2]["q_type_id"] == this.QUESTION_TYPE.TEXTAREA
          || main2List[mq2]["q_type_id"] == this.QUESTION_TYPE.DATEYYYYMMFROMTO
          || main2List[mq2]["q_type_id"] == this.QUESTION_TYPE.LABELTEXT1
        ) continue;

        main2List[mq2]["check"] = this.isMainGraphShow;
        let main3List = main2List[mq2]["n_question_list"];
        for (let mq3 in main3List) {
          if (main3List[mq3]["q_type_id"] == this.QUESTION_TYPE.TEXTBOX
            || main3List[mq3]["q_type_id"] == this.QUESTION_TYPE.TEXTAREA
            || main3List[mq3]["q_type_id"] == this.QUESTION_TYPE.DATEYYYYMMFROMTO
            || main3List[mq3]["q_type_id"] == this.QUESTION_TYPE.LABELTEXT1
          ) continue;

          main3List[mq3]["check"] = this.isMainGraphShow;
        }
      }
    }
  }

  goBack(): void {
    this.location.back();
  }

}



// WEBPACK FOOTER //
// ./src/app/a0114-result-analysis/a0114-result-analysis.component.ts